import { render, staticRenderFns } from "./FileProprietaryData.vue?vue&type=template&id=5b27277e"
import script from "./FileProprietaryData.vue?vue&type=script&lang=ts"
export * from "./FileProprietaryData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports